"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const HelperUtils_1 = require("utils/HelperUtils");
const Button_1 = __importDefault(require("components/design-system/Button"));
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
const ModalImportScore_1 = __importDefault(require("./ModalImportScore"));
const ImportScoreSections = ({ cycleId, getUserCycle }) => {
    const [isModalOpen, setModalOpen] = (0, react_1.useState)(false);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Button_1.default.Secondary, { customClass: "ml-[8px]", onClick: () => setModalOpen(true) },
            react_1.default.createElement(SVGIcon_1.default, { iconName: "icon-file_upload", size: 20, fillColor: "var(--n-600)", customClass: "pr-[16px]", dataCy: "export-csv" }),
            (0, HelperUtils_1.getObjectiveLocale)('Import Score')),
        isModalOpen && (react_1.default.createElement(ModalImportScore_1.default, { eventClose: () => setModalOpen(false), cycleId: cycleId, getUserCycle: getUserCycle }))));
};
exports.default = ImportScoreSections;
